import React, { useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';

const LabelFields = [
    { label: 'Name', name: 'name', type: 'text', required: true},
    { label: 'Color', name: 'color', type: 'picklist', required: true, options: ['red', 'green', 'blue', 'yellow', 'orange']},
];



const NewLabel = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    return (
        <div>
            
                <button className="custom-button" onClick={toggleModal}>
                    New Label
                </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddEntity
                    toggleFunction={toggleModal}
                    title="Add Label"
                    formFields={LabelFields}
                    apiFunction={ApiManager.addLabel}
                    onSuccess={onSuccess}
                />
            </Modal>
        </div>
    );
};

export default NewLabel;
